import React from 'react'
import { withTranslation } from 'react-i18next';

const DownloadCTA = ({logos, t, i18n}) => (
  <div className="DownloadCTA nopadding text-center buttons">
    <div className={"DownloadCTA__wrapper"}>
      <a href={`https://app.duuers.com/auth/signup?lng=${i18n.language}`} className="btn size60 white semibold uppercase radius6 DownloadCTA__free">
        <span>{t('menu.signup')}</span>
      </a>
      <div className={"DownloadCTA__separator"}>
        <span className="DownloadCTA__separator__line"></span>
        <span className={`DownloadCTA__separator__letter`}>{t('component.signup.or')}</span>
        <span className={"DownloadCTA__separator__line"}></span>
      </div>
      <a href={`https://www.duuers.com/`} className="btn size60 padding_sides35 radius6 semibold uppercase DownloadCTA__learn">{t('menu.findout')}</a>
    </div>
  </div>
)

export default withTranslation()(DownloadCTA);
